

function AdMarketing(props) {
    return (
        <div >
            <div className="recruit_contents">
                <div className="recruit_titleline_w">
                    <h4 className="recruit_titleline_info">경영</h4>
                    <h5 className="recruit_titleline_title">광고마케팅</h5>
                </div>
                <div className="recruit_subtitleline_w">
                    <h6 className="recruit_titleline_info">직무소개</h6>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                    <p className="recruit_subinfo_text">
                        광고마케팅 직무는 SBS의 주요한 수익원인 방송광고/디지털 광고 업무를 총괄하고, SBS 콘텐츠를<br />
                        기반으로 광고주에게 다양한 마케팅 솔루션을 제공하는 직무입니다. 직무의 주요 내용으로는,<br />
                        SBS 플랫폼에 송출되는 다양한 유형의 광고 상품 및 관련 제도를 기획하고 판매 증진을 위한<br />
                        전략을 수립합니다. 또 SBS 채널에 광고 소재가 원활히 송출될 수 있도록 하는 운행 업무도<br />
                        포함되어 있습니다.<br />
                        한편, SBS의 다양한 콘텐츠를 활용한 광고주의 마케팅 활동을 기획 및 제안하는 역할도<br /> 
                        담당하고 있습니다. 프로그램 협찬 영업, 간접/가상광고 판매, 디지털 브랜디드 콘텐츠 기획 및<br />
                        영업 등 개별 프로그램과 마케팅 니즈가 있는 광고주를 연결하고 소통하는 직무입니다.<br /><br />
     
                        광고마케팅 직무는 회사의 가장 중요한 수익원을 책임짐과 동시에 여러 부서와 긴밀한 협력을 통해<br /> 
                        신규 상품을 지속적으로 개발하는 도전적인 업무를 담당합니다. 따라서 호기심이 많고 새로운 시도를<br /> 
                        즐기며 문제 해결에 성취감을 느끼는 분들에게 추천해 드립니다. 사내외 지속적인 교류를 통해 시장의<br /> 
                        니즈를 파악하여 최적의 솔루션을 제공해야 하므로 분석력 및 커뮤니케이션 능력도 요구됩니다.<br />
                        또한, 다양한 분야에 관심을 갖고 트렌드를 파악하는 능력이 있는 분이라면 빠르게 변화하는 콘텐츠<br /> 
                        마케팅 시장에서 새로운 솔루션을 제시하는 데 도움이 될 수 있을 것입니다.<br /> 
                        요즘은 어떤 콘텐츠가 재미있는지, 어떤 마케팅 사례가 눈에 띄는지 등에 관심이 많다면<br /> 
                        업무에 더 도움이 되지 않을까요?
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">부서 소개</h7>
                    <p className="recruit_subinfo_text">
                        광고마케팅팀은 크게 일반TV광고/디지털 광고 판매 기획 및 송출운행을 담당하는 ‘광고’ 파트와<br />  
                        SBS의 각 프로그램 내에 협찬, 간접/가상광고, 캠페인 등을 유치하는 ‘마케팅’ 파트로 나눌 수 있습니다.
                    </p>
                    <em className="recruit_bold_text">일반 광고 업무</em>
                    <p className="recruit_subinfo_text">
                        주요 광고 계약 관리 및 광고 목표, 매출 관리<br />  
                        상품 요금 및 판매 제도 관리<br />  
                        광고 설명회 개최<br />  
                        CM 운행 및 광고 소재 편집, 관리 
                    </p>
                    <em className="recruit_bold_text">디지털광고 업무</em>
                    <p className="recruit_subinfo_text">
                        디지털 광고 계약 관리 및 목표, 매출 관리<br />
                        디지털 판매 재원 및 상품 개발<br />
                        디지털 광고주 및 렙사 영업 등<br />
                    </p>
                    <em className="recruit_bold_text">마케팅 파트</em>
                    <p className="recruit_subinfo_text">
                        SBS 예능/교양/디지털 프로그램별 협찬, 간접, 가상 광고 영업<br />
                        협찬, 간접, 가상광고 프로그램 내 반영<br />
                        TV/라디오 캠페인 영업 및 선거 광고 및 연설 판매<br />
                        간접, 가상광고 관련 제도 개선<br />
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                    <p className="recruit_subinfo_text">
                        미디어 산업은 그 어떤 산업보다 흥미롭게 급변하고 있는 산업입니다. 수많은 플랫폼과 콘텐츠가 탄생하고 있으며,<br />
                        성공과 실패를 경험하고 있습니다. 어떠한 산업이건 비즈니스의 성장을 위해서는 지속해서 수익원을 발굴하여<br />
                        유지하는 것이 핵심입니다.<br />
                        따라서 이러한 비즈니스의 최전방인 광고마케팅팀에서 커리어를 쌓는다면 미디어 기업의 비즈니스 모델에 대해<br />
                        깊게 이해할 수 있는 계기가 될 것입니다. 특히, 콘텐츠를 제작하는 제작진과 광고주, 또 사내 여러<br />
                        유관 부서와 끊임없는 협의와 소통을 하지 않을 수 없는 부서이므로 이를 통해 쌓은 네트워크를 기반으로 향후<br />
                        전략, 기획, 사업 등 다양한 타 부서로의 이동도 생각해볼 수 있습니다.
                    </p>
                </div>
                <div className="recruit_subtitleline_w">
                    <h6 className="recruit_titleline_info">선배인터뷰</h6>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">본인 소개</h7>
                    <p className="recruit_subinfo_text">
                        안녕하세요, SBS 광고마케팅팀에 근무중인 최서윤이라고 합니다.<br />
                        저는 2016년에 SBS에 입사 후 인사팀에서 근무하다 현재 광고마케팅팀에서 근무한지는 3년 정도 됐습니다.<br />
                        현재 예능 프로그램 마케팅을 담당하고 있습니다.<br />
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">이 업무를 하게 된 계기는?</h7>
                    <p className="recruit_subinfo_text">
                        인사팀에서 근무하며 다양한 부서 업무에 대해 접하게 되었고, 부서를 옮길 수 있는 기회가 됐을 무렵 당시<br />
                        새로 생긴 부서였던 마케팅팀에서 일해보고 싶다는 생각이 들었습니다.<br />
                        콘텐츠 회사에 근무하는 만큼, 제작 사이드와 밀접하게 일할 수 있으면서도 광고 시장에 대한 이해도도<br />
                        높일 수 있는 부서라고 생각했기 때문입니다. 감사하게도 마케팅 부서에서 일할 수 있는 기회를 얻게 돼,<br />
                        초반에는 캠페인 파트에서 라디오 캠페인 판매 업무를 담당했고 현재는 SBS 주요 예능 프로그램의<br />
                        마케팅을 담당하고 있습니다. 
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                    <p className="recruit_subinfo_text">
                        아무래도 광고주와 제작진 사이에서 업무를 진행하기 때문에 양쪽 모두 만족하는 결과를 얻을 때 보람을 느낍니다.<br />
                        광고주의 마케팅 메시지가 딱 맞는 프로그램에 자연스럽게 녹아 들었을 때, 제작진이 광고 매출을 통해 더 풍성한<br />
                        프로그램을 제작할 수 있는 경우 등 저와 팀원들이 하는 업무가 콘텐츠 광고 시장에 좋은 사례를 남길 수 있을 때<br />
                        업무에 대한 만족도 높아지는 것 같습니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                    <p className="recruit_subinfo_text">
                        다양한 경험을 해보고 싶은 지원자라면 SBS와 함께하자고 말하고 싶습니다. ‘규모’라는건 개인적인 기준일 수 있지만,<br />
                        SBS의 경우 규모가 매우 큰 조직은 아닙니다. 하지만 그만큼 효율적이고 각 개인이 커버하는 업무의 폭이 상당히<br />
                        넓기도 합니다.<br />
                        저 또한 인사 업무를 하다가 현재 마케팅팀에서 업무를 하고 있는 것처럼 개인에게 주어지는 기회의 폭도 다양한 편이죠.<br />
                        커리어의 스펙트럼을 넓히고 싶은 분들에게는 최고의 선택이라고 할 수 있습니다.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AdMarketing;

